<template>
  <master-crud-page
    master="sensor_type"
    title="Sensor Type"
    access="master_sensor_type"
    pk="mstyId"
    :columns="columns"
    :fields="fields"
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';

export default {
  name: 'MasterSensorType',
  components: { MasterCrudPage },
  data() {
    return {
      columns: [
        { key: 'mstyName', label: 'Sensor Type Name', align: 'left' },
        { key: 'mstyCreatedUserId', label: 'Created By', align: 'center' },
        {
          key: 'mstyCreatedTime',
          label: 'Created',
          align: 'center',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'mstyName',
          label: 'Sensor Type Name',
          type: 'text',
          required: true,
        },
      ],
    };
  },
};
</script>
